import PropTypes from 'prop-types';
import { useState } from 'react';
// @mui
import { Stack, Button, TableRow, MenuItem, TableCell, IconButton, Typography, alpha } from '@mui/material';
// components
import Iconify from '../../../../components/iconify';
import MenuPopover from '../../../../components/menu-popover';
import ConfirmDialog from '../../../../components/confirm-dialog';
import ContainedButton from '../../../../components/actions/ContainedButton';
import { onGetFullname, replaceBasfWithWalmart } from '../../../../utils/general';
import { catalogs } from '../../../../utils/catalogs';
import Label from '../../../../components/label/Label';
import { useBoolean } from '../../../../hooks/useBoolean';
import EditClientProgramStatusModal from '../../../../modals/programs/EditClientProgramStatusModal';

// ----------------------------------------------------------------------

UserProgramTableRow.propTypes = {
  row: PropTypes.object,
  selected: PropTypes.bool,
  onEditRow: PropTypes.func,
  onDeleteRow: PropTypes.func,
  onSelectRow: PropTypes.func,
};

export default function UserProgramTableRow({ row, selected, onRefresh, onSelectRow, onDeleteRow, admin, show_nutritionist }) {
  const { id_user, email, employee_number, mobile, mobile_country_code, nutrio } = row;

  const edit_status_modal = useBoolean()
  const [openConfirm, setOpenConfirm] = useState(false);

  const [openPopover, setOpenPopover] = useState(null);

  const handleOpenConfirm = () => {
    setOpenConfirm(true);
  };

  const handleCloseConfirm = () => {
    setOpenConfirm(false);
  };

  const handleOpenPopover = (event) => {
    setOpenPopover(event.currentTarget);
  };

  const handleClosePopover = () => {
    setOpenPopover(null);
  };

  const userdata = {
    first_name:row?.user_first_name,
    fathers_last_name:row?.user_fathers_last_name,
    mothers_last_name:row?.user_mothers_last_name,
  }


  const statusData = catalogs.user_client_program_statuses.find(el => el.value == row?.user_client_program_status_id)

  return (
    <>
      <TableRow hover selected={selected}>
        <TableCell sx={{cursor:'pointer', minWidth: 200, maxWidth:300}} padding='checkbox'  onClick={onSelectRow}>
          <Stack direction="column"  spacing={0 }>
            <Typography variant="subtitle2">
              {onGetFullname(userdata)}
            </Typography>
            <Typography variant='body2'>
              {replaceBasfWithWalmart(row?.user_email)}
            </Typography>
          </Stack>
        </TableCell>
        {/*<TableCell sx={{cursor:'pointer'}} align="left" onClick={onSelectRow}>
          {row?.user_employee_number}
        </TableCell>*/}
        <TableCell padding='checkbox' onClick={() => edit_status_modal.onTrue()}>
          <Label sx={{
            background: alpha(statusData?.color,0.2),
            color:statusData?.color,px:1,
            cursor:'pointer'
          }}>
            {statusData?.label}
          </Label>
        </TableCell>
        <TableCell sx={{cursor:'pointer'}} align="left" onClick={onSelectRow}>{row?.user_rfc ?? '-'}</TableCell>
        <TableCell sx={{cursor:'pointer'}} align="left" onClick={onSelectRow}>{row?.user_employee_number ?? '-'}</TableCell>
        <TableCell sx={{cursor:'pointer'}} align="left" onClick={onSelectRow}>{row?.user_client_location ?? '-'}</TableCell>
        <TableCell align="right">
          <IconButton color={openPopover ? 'inherit' : 'default'} onClick={handleOpenPopover} >
            <Iconify icon="eva:more-vertical-fill" />
          </IconButton>
        </TableCell>
      </TableRow>

      <MenuPopover open={openPopover} onClose={handleClosePopover} arrow="right-top" sx={{ width: 140 }}>
        <MenuItem
          onClick={() => {
            handleOpenConfirm();
            handleClosePopover();
          }}
          sx={{ color: 'error.main' }}
        >
          <Iconify icon="eva:trash-2-outline" />
          Eliminar
        </MenuItem>

        
      </MenuPopover>
        <EditClientProgramStatusModal 
          origin={row}
          open={edit_status_modal.value}
          onClose={() => edit_status_modal.onFalse()}
          onRefresh={onRefresh}
        />
      <ConfirmDialog
        open={openConfirm}
        onClose={handleCloseConfirm}
        title="Eliminar usuario"
        content="¿Está seguro de eliminar este usuario? Ya no podrá recuperarse en un futuro"
        action={
          <ContainedButton size='small' onClick={onDeleteRow}>
            Eliminar
          </ContainedButton>
        }
      />
    </>
  );
}
